import request from '@/utils/request'
//删除用户足迹
export function deleteHistyry(data) {
  return request({
    url: '/wx/footprint/delete',
    method: 'post',
    data: data
  })
}

//用户足迹列表
export function getList(params) {
  return request({
    url: '/wx/footprint/list',
    method: 'get',
    params: params
  })
}

//用户搜索历史记录
export function getHistorylist(params){
  return request({
    url: '/wx/search/index',
    method: 'get',
    params: params,
  });
}

//清空历史记录
export function clearhistory(params){
  return request({
    url: '/wx/search/clearhistory',
    method: 'post',
    params: params,
  });
}



// WEBPACK FOOTER //
// ./src/api/history/history.js